import React, { useContext, useEffect, useState, useRef } from "react";
import config, { getParameterByName, merchantCode, getPriceWithIncrease } from "../util";
import { Store } from "../Store";
import Chip from "@mui/material/Chip";
import axios from "axios";
import Slider from "react-slick";
import SearchBar from '../components/SearchBar';
import {
  addToOrder, clearOrder, removeFromOrder, listCategories,
  listProducts,
} from "../actions";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  ClickAwayListener,
  Slide,
  Fab,
  IconButton,
  MenuList,
  MenuItem,
  Zoom,
  Popper,
  Grow,
  Paper,

  AppBar,
  Toolbar,
  TextField,
  Typography,

  Switch,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core";
import HomeIcon from '@mui/icons-material/Home';
import GradingIcon from '@mui/icons-material/Grading';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useLocation, useHistory } from 'react-router-dom';
import PlaceIcon from '@mui/icons-material/Place';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'; // Add this import
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'; // Add this import
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { useStyles } from "../styles";
import MainFooter from "../components/MainFooter";
import CartReview from "../components/Cart_Review";
import OrderCustomize from "../components/Order_Customize";
import CartButton from "../components/Cart_Button";
import BackButton from '../components/Back_Button';
import Categories from '../components/Categories';
import ProductList from '../components/Product_List';

import FeaturedSlider from '../components/FeaturedSlider'; // Add this import

import ReserveTable from './ReserveTable';
import SlidingPane from "react-sliding-pane";
import SignUp from './SignUp';
import "react-sliding-pane/dist/react-sliding-pane.css";
import ReviewScreen from "./ReviewScreen";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useIntl } from "react-intl";
//import bgImg from '../assets/image/bg.jpg';
import SearchIcon from '@material-ui/icons/Search';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { Landscape } from "@material-ui/icons";

export default function OrderScreen(props) {
  const styles = useStyles();
  const history = useHistory();
  const { formatMessage: t, locale, setLocale } = useIntl();
  const { state, dispatch } = useContext(Store);
  const { categories, loading, error } = state.categoryList;
  let { customizeInWizard } = state;
  const [orderItem, setOrderItem] = useState(null);
  let pgSets = { customizeInWizard };
  let { promos } = state.promos;
  const splashScreens = promos.filter(pr => pr.useAt == 'ONLINE_BANNER');
  console.log(splashScreens);
  const {
    products,
    loading: loadingProducts,
    error: errorProducts,
  } = state.productList;
  const { orderItems = [], itemsCount = 0, totalPrice = 0, taxPrice = 0, orderType = '' } =
    state.order || {};
  const [quantity, setQuantity] = useState(1);
  const [selectedCat, setSelectedCat] = useState("");
  const [isReservePaneOpen, setReservePaneOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Add state for search query
  const [isVegOnly, setIsVegOnly] = useState(false); // Uncomment this line
  //const [isVegOnly, setIsVegOnly] = useState(false);
  //dialogs state
  const [tabSel, setTabSel] = React.useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const [openSign, setOpenSign] = useState(false);
  const anchorRef = React.useRef(null);
  const baseURL = config.baseURL;
  let { setting } = state.userSetting;
  let { userInfo } = state.userData;
  const themeColor = userInfo?.themeColor || '#ffbc01';
  const themeTxtColor = userInfo?.themeTxtColor || '#000';
  const customersInfo = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : "";
  if (!setting) {
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }

  let userData = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
  // if (userData) {
  //   let body = document.getElementsByTagName("body");
  //   //body[0].style.backgroundColor = setting.color_tirnary;
  //   setTimeout(() => {
  //     let textcolor = document.getElementById("title1");
  //     textcolor.style.color = userData.color_primary;
  //   }, 10);
  // }
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Add state for profile menu
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const [showPickupAddress, setShowPickupAddress] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState(false);

  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const searchIconRef = useRef(null);
  // const arrowRef = useRef(null);
  // // Responsive popover width
  // const [popoverWidth, setPopoverWidth] = useState(340);


  useEffect(() => {
    listCategories(dispatch);
    listProducts(dispatch);
  }, []);

  const getCurrentAddrss = () => {

    //https://dev.virtualearth.net/REST/v1/Locations/15.465810,75.005360?o=json&key=ArW_TkF5xKfdKeIe4Ac-IQaAI7Mm3FLkRbPaj0g5EqEvF01MqV5JMR-ABy2BxrPd
  }

  const closeHandler = () => {
    setIsCustomizeOpen(false);
    setIsCartOpen(false);
    setIsOpen(false);
  };

  const vegHandler = () => {
    setIsVegOnly(!isVegOnly);
  };

  const categoryClickHandler = (cat) => {
    console.log(cat);
    setSelectedCat(cat);
    setIsCategoryMenuOpen(false);
  };

  const addToOrderHandler = (customInstr) => {
    //Set price if variety price availabe
    let varName = Object.keys(orderItem.sub_pro.variety);
    let selectedPrice = varName.length
      ? parseFloat(orderItem.sub_pro.variety[varName[0]])
      : orderItem.price;

    customInstr.length && orderItem.sub_pro.cookInstructions.push(customInstr);
    
    const increaseBy = orderItem.onlineIncreaseBy || 0;
    const finalBasePrice = getPriceWithIncrease(selectedPrice, increaseBy);

    addToOrder(dispatch, { ...orderItem, price: finalBasePrice, basePrice: selectedPrice, quantity });
    setIsCustomizeOpen(false);
    setOrderItem(null);
    let isEditOrdItem = orderItems.filter(om => om.id == orderItem.id).length;
    isEditOrdItem && setIsCartOpen(true);
  };

  const productClickHandler = (p, isEditOrder) => {
    let pCopy = { ...p };
    if (!isEditOrder) {
      pCopy['sub_pro'] = {};
      pCopy.sub_pro['addons'] = [];
      pCopy.sub_pro['variety'] = {};
      pCopy.sub_pro['cookInstructions'] = [];
      pCopy['basePrice'] = p.price;
    } else {
      // If editing, extract the base price if we stored it, otherwise use current price
      pCopy['price'] = p.basePrice || p.price; 
    }
    setOrderItem(pCopy);
    setIsCartOpen(false);
    setIsCustomizeOpen(!isCustomizeOpen);
  };

  const removeOrderItm = () => {
    setIsCustomizeOpen(false);
    setOrderItem(null);
    removeFromOrder(dispatch, orderItem);
  };

  const procedToCheckoutHandler = () => {
    let loginData = sessionStorage.getItem('customerInfo');
    loginData = JSON.parse(loginData);
    if (loginData !== null) {
      props.history.push("/collection-mode?" + window.location.href.split('?')[1]);
    } else {
      setOpenSign(true);
      // setIsCartOpen(false);
    }
  };
  const goto = (subpath) => {
    history.push('/' + subpath + '?' + window.location.href.split('?')[1]);
  }
  const previewOrderHandler = () => {
    props.history.push("/payment?" + window.location.href.split("?")[1]);
  };

  const handleCart = (cartItems) => {
    console.log("Cart");
    if (cartItems == 0) return;
    setIsCartOpen(true);
  };

  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "./images/blank.jpg";
  };

  const handleBack = () => {
    if (isCartOpen || isCustomizeOpen) {
      setIsCartOpen(false);
      setIsCustomizeOpen(false);
    } else {
      props.history.push(`/choose?` + window.location.href.split("?")[1]);
    }
  };

  const handleToggle = () => {
    setIsCategoryMenuOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setIsCategoryMenuOpen(false);
  };

  // Add handler for profile menu
  const handleProfileMenuToggle = () => {
    // setProfileMenuOpen((prev) => !prev);
  };

  const handleProfileMenuClose = (event) => {
    // if (profileRef.current && profileRef.current.contains(event.target)) {
    //   return;
    // }
    // setProfileMenuOpen(false);
  };

  const filteredProducts = products ? products.filter(product =>
    (searchQuery === "" || product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (product.description && product.description.toLowerCase().includes(searchQuery.toLowerCase()))) &&
    (!isVegOnly || (isVegOnly && product.cat_type.toLowerCase() === 'veg'))
  ) : [];

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "./images/blank.jpg";
    if (imagePath.startsWith('http')) return imagePath;
    return `${baseURL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  // get address or coords from SelectPaymentScreen
  const query = new URLSearchParams(props.location.search);
  const addressParam = query.get('address') || userData?.address;
  const latParam = query.get('lat');
  const lngParam = query.get('lng');
  const [displayAddress, setDisplayAddress] = useState("");
  // determine label based on orderType
  const isPickup = orderType?.toLowerCase().includes('pick');
  const headerLabel = isPickup ? 'Pickup at: ' : 'Delivery at: ';
  // reverse geocode if coords provided
  useEffect(() => {

    if (!isPickup && (latParam && lngParam)) {
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latParam}&lon=${lngParam}&format=json`)
        .then(res => res.json())
        .then(data => {
          if (data.display_name) setDisplayAddress(data.display_name);
        })
        .catch(() => setDisplayAddress(addressParam));
    }
    if (isPickup && userData.location) {
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${userData.location.coordinates[0]}&lon=${userData.location.coordinates[1]}&format=json`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          if (data.display_name) setDisplayAddress(data.display_name);
        })
        .catch(() => setDisplayAddress(addressParam));
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  // Group products by category for accordion view
  const getProductsByCategory = (categoryId) => {
    return filteredProducts.filter(product => product.category === categoryId && product.inStock);
  };

  return (
    <Box
      className={styles.root}
      style={{
        padding: "0px!important",
        backgroundColor: '#ffffff',
        backgroundImage: `linear-gradient(180deg, ${setting.themeColor} 0%, #ffffff 40%)`,
        fontFamily: 'Acme, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
      id={"order-root"}
    /* Chrome, Safari, Opera*/
    >
      <div style={{ height: "50px", width: "100%", display: "flex", justifyContent: "space-between", padding: "5px", fontFamily: setting.themeSecondaryFontFam }}>
        <div style={{ fontSize: "1.4em", width: "150px", marginLeft: "5px", color: "#fff", marginTop: "0px", display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          <span style={{ marginLeft: '10px', color: setting.themeTxtColor }}>{`Welcome! ${customersInfo?.customer?.firstName || "Guest"}`}</span>

        </div>
        <div style={{ paddingTop: "1px", maxWidth: "150px", display: 'flex', alignItems: 'center', justifyContent: 'flex-end', color: setting.themeTxtColor, fontWeight: 500, fontFamily: setting.themeSecondaryFontFam, marginRight: "10px" }}>

          {(customersInfo && customersInfo.customer && customersInfo.customer.address) && (
            <div
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', maxWidth: '100%' }}
              onClick={(e) => {
                setSearchAnchorEl(e.currentTarget);
                setShowPickupAddress(true);
              }}
            >
              <FmdGoodOutlinedIcon style={{ fontSize: 22, marginRight: "4px", flexShrink: 0 }} />
              <span style={{ fontSize: '0.85em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {customersInfo.customer.address}
              </span>
            </div>
          )}

        </div>

      </div>
      <div style={{ padding: "0 10px 10px 10px", width: "100%", boxSizing: "border-box" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "5px 10px",
          width: "100%",
          boxSizing: "border-box",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <SearchIcon style={{ color: "#666", marginRight: "8px" }} />
          <input
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="Search menu items..."
            style={{
              width: "100%",
              border: "none",
              outline: "none",
              fontFamily: setting.themeSecondaryFontFam,
              fontSize: "1em",
              color: "#000",
              backgroundColor: "transparent"
            }}
          />
        </div>
      </div>
      {!isLandscape && <div className={styles.promo} style={{ padding: "0px 10px", height: "160px", overflow: "hidden" }}>
        <Slider {...settings} autoplay={true} autoplaySpeed={2000}>

          {splashScreens.map(splash => (<div >
            <img style={{ borderRadius: "10px" }} src={splash?.url} className={styles.promoImg} />
          </div>))
          }
        </Slider>
      </div>}


      {/* Fixed header section */}

      {isLandscape ? (
        userData?.OO_default_categoryView === 'collapsable' ? (
          // Collapsible accordion view for landscape with cart on right
          <Grid container spacing={1} style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
            {/* Left side: Accordion categories (65% width) */}
            <Grid item xs={8} style={{ height: "100%", overflowY: "auto", padding: "10px", borderRight: "1px solid rgba(0,0,0,0.1)" }}>
              <Typography variant="h4" style={{ color: userData.themeTxtColor, marginBottom: "20px", textAlign: 'center' }}>{t({ id: "categories" })}</Typography>
              {categories && categories
                .filter(cat => cat.isOrderableAlone || !cat.isAddOn)
                .map((category) => {
                  const categoryProducts = getProductsByCategory(category.id);
                  if (categoryProducts.length === 0) return null;
                  
                  return (
                    <Accordion
                      key={category.id}
                      expanded={expandedPanel === category.id}
                      onChange={handleAccordionChange(category.id)}
                      style={{
                        backgroundColor: userData.themeTxtColor || '#fff',
                        marginBottom: '15px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        border: `1px solid ${userData.themeColor}30`
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: userData.themeColor, fontSize: '2rem' }} />}
                        style={{
                          backgroundColor: userData.themeColor + '15',
                          borderRadius: '12px',
                          minHeight: '80px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Avatar
                            src={getImageUrl(category.image)}
                            alt={category.name}
                            variant="rounded"
                            style={{ 
                              width: 50, 
                              height: 50, 
                              marginRight: '20px',
                              border: `3px solid ${userData.themeColor}`
                            }}
                          />
                          <Typography 
                            variant="h4" 
                            style={{ 
                              color: userData.themeColor,
                              fontWeight: 700,
                              flex: 1
                            }}
                          >
                            {category.name}
                          </Typography>
                          <Typography 
                            variant="h6" 
                            style={{ 
                              color: userData.themeColor + '90',
                              fontSize: '1.2rem'
                            }}
                          >
                            {categoryProducts.length} items
                          </Typography>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: '20px' }}>
                        <ProductList
                          items={categoryProducts}
                          baseURL={baseURL}
                          pgSets={pgSets}
                          userData={userData}
                          imageOnErrorHandler={imageOnErrorHandler}
                          productClickHandler={productClickHandler}
                          categories={categories ? categories : []}
                          selectedCat={{ id: category.id }}
                          style={{ backgroundColor: themeColor }}
                          t={t}
                          isLandscape={isLandscape}
                        />
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </Grid>

            {/* Right side: Cart (35% width) */}
            <Grid item xs={4} style={{ height: "100%", overflowY: "auto", borderLeft: "1px solid rgba(0,0,0,0.1)" }}>
              <CartReview
                t={t}
                orderItems={orderItems}
                setIsCartOpen={setIsCartOpen}
                productClickHandler={productClickHandler}
                categories={categories ? categories : []}
                procedToCheckoutHandler={procedToCheckoutHandler}
                style={{ backgroundColor: themeColor }}
                isLandscape={isLandscape}
              />
            </Grid>
          </Grid>
        ) : userData?.OO_default_categoryView === 'chips_scroll' ? (
          // Chips scroll view for landscape with cart on right
          <Grid container spacing={1} style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
            {/* Left side: Content with chips (65% width) */}
            <Grid item xs={8} style={{ height: "100%", overflowY: "auto", borderRight: "1px solid rgba(0,0,0,0.1)", display: 'flex', flexDirection: 'column' }}>
              {/* Horizontal scrollable category chips */}
              <Box style={{
                padding: '5px',
                backgroundColor: '#ffffff',
                borderBottom: 'none',
                position: 'sticky',
                top: 0,
                zIndex: 10,
                flexShrink: 0
              }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    overflowX: 'scroll',
                    overflowY: 'hidden',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    padding: '8px 0px',
                    width: '100%',
                    WebkitOverflowScrolling: 'touch'
                  }}
                  onScroll={(e) => {
                    e.preventDefault();
                  }}
                >
                  <style jsx>{`
                    div::-webkit-scrollbar {
                      display: none;
                    }
                    div {
                      -ms-overflow-style: none;
                      scrollbar-width: none;
                    }
                  `}</style>
                  {categories && categories
                    .filter(cat => cat.isOrderableAlone || !cat.isAddOn)
                    .map((category) => {
                      const categoryProducts = getProductsByCategory(category.id);
                      if (categoryProducts.length === 0) return null;
                      
                      return (
                        <Chip
                          key={category.id}
                          style={{ 
                            border: selectedCat?.id === category.id ? `1px solid ${userData.themeTxtColor}` : 'none'
                          }}
                          label={
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '10px', whiteSpace: 'nowrap',  }}>
                              <Avatar
                                src={getImageUrl(category.image)}
                                alt={category.name}
                                style={{ 
                                  width: 28, 
                                  height: 28, 
                                                                  }}
                              />
                              <span style={{ 
                                fontWeight: selectedCat?.id === category.id ? 700 : 600,
                                color: selectedCat?.id === category.id ? userData.themeTxtColor : 'inherit',
                                fontSize: '0.95rem'
                              }}>
                                {category.name}
                              </span>
                              <span style={{ 
                                fontSize: '0.8rem',
                                opacity: 0.8,
                                color: selectedCat?.id === category.id ? userData.themeTxtColor : 'inherit'
                              }}>
                                ({categoryProducts.length})
                              </span>
                            </Box>
                          }
                          onClick={() => {
                            setSelectedCat(category);
                            setExpandedPanel(false);
                          }}
                          style={{
                            backgroundColor: selectedCat?.id === category.id ? userData.themeColor : 'transparent',
                            color: selectedCat?.id === category.id ? userData.themeTxtColor : userData.themeTxtColor,
                            border: `2px solid ${userData.themeColor}`,
                            borderRadius: '25px',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            padding: '10px 6px',
                            height: 'auto',
                            minWidth: 'fit-content',
                            flexShrink: 0,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            whiteSpace: 'nowrap'
                          }}
                        />
                      );
                    })}
                </div>
              </Box>

              {/* Products for selected category or all products */}
              <Box style={{ padding: '15px', flexGrow: 1, overflowY: "auto" }}>
                <Typography
                  variant="h5"
                  style={{
                    color: userData.themeTxtColor,
                    marginBottom: '20px',
                    fontWeight: 700,
                    textAlign: 'center'
                  }}
                >
                  {selectedCat ? selectedCat.name : 'All Items'}
                </Typography>
                <ProductList
                  items={selectedCat ? getProductsByCategory(selectedCat.id) : filteredProducts}
                  baseURL={baseURL}
                  pgSets={pgSets}
                  userData={userData}
                  imageOnErrorHandler={imageOnErrorHandler}
                  productClickHandler={productClickHandler}
                  categories={categories ? categories : []}
                  selectedCat={selectedCat}
                  style={{ backgroundColor: themeColor }}
                  t={t}
                  isLandscape={isLandscape}
                />
              </Box>
            </Grid>

            {/* Right side: Cart (35% width) */}
            <Grid item xs={4} style={{ height: "100%", overflowY: "auto", borderLeft: "1px solid rgba(0,0,0,0.1)" }}>
              <CartReview
                t={t}
                orderItems={orderItems}
                setIsCartOpen={setIsCartOpen}
                productClickHandler={productClickHandler}
                categories={categories ? categories : []}
                procedToCheckoutHandler={procedToCheckoutHandler}
                style={{ backgroundColor: themeColor }}
                isLandscape={isLandscape}
              />
            </Grid>
          </Grid>
        ) : (
          // Original landscape three-column layout
          <Grid container spacing={1} style={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
            {/* Left Column: Categories */}
            <Grid item xs={2} style={{ height: "100%", overflowY: "auto", borderRight: "1px solid rgba(0,0,0,0.1)" }}>
              <Box style={{ padding: "10px" }}>
                <Typography variant="h4" style={{ color: userData.themeTxtColor, marginBottom: "10px" }}>{t({ id: "categories" })}</Typography>
                {categories && categories.map((category) => (
                  <MenuItem
                    key={category.id}
                    onClick={() => categoryClickHandler(category)}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      backgroundColor: selectedCat.id === category.id ? 'rgba(255,255,255,0.2)' : 'transparent',
                      borderRadius: '8px',
                      marginBottom: '5px',
                      padding: '8px 12px',
                      borderBottom: `1px solid ${userData.themeTxtColor}22`
                    }}
                  >
                    <Avatar
                      src={getImageUrl(category.image)}
                      alt={category.name}
                      variant="rounded"
                      style={{ width: 40, height: 40, marginRight: '12px' }}
                    />
                    <Typography variant="body1" style={{ color: userData.themeTxtColor, fontWeight: 700 }}>{category.name}</Typography>
                  </MenuItem>
                ))}
              </Box>
            </Grid>

            {/* Middle Column: Products */}
            <Grid item xs={7} style={{ height: "100%", overflowY: "auto" }}>
              <Box style={{ padding: "10px" }}>
                {/* Explore Menu title removed */}
                <ProductList
                  items={filteredProducts}
                  baseURL={baseURL}
                  pgSets={pgSets}
                  userData={userData}
                  imageOnErrorHandler={imageOnErrorHandler}
                  productClickHandler={productClickHandler}
                  categories={categories ? categories : []}
                  selectedCat={selectedCat}
                  style={{ backgroundColor: themeColor }}
                  t={t}
                  isLandscape={isLandscape}
                />
              </Box>
            </Grid>

            {/* Right Column: Cart */}
            <Grid item xs={3} style={{ height: "100%", overflowY: "auto", borderLeft: "1px solid rgba(0,0,0,0.1)" }}>
              <CartReview
                t={t}
                orderItems={orderItems}
                setIsCartOpen={setIsCartOpen}
                productClickHandler={productClickHandler}
                categories={categories ? categories : []}
                procedToCheckoutHandler={procedToCheckoutHandler}
                style={{ backgroundColor: themeColor }}
                isLandscape={isLandscape}
              />
            </Grid>
          </Grid>
        )
      ) : (
        <Box style={{
          overflowX: 'hidden',
          overflowY: 'auto',
          marginTop: '5px',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          height: "calc(100vh - 315px)",
          paddingBottom: "120px",
        }}>
          {userData?.OO_default_categoryView === 'collapsable' ? (
            // Accordion view for categories
            <Box style={{ padding: '10px' }}>
              {categories && categories
                .filter(cat => cat.isOrderableAlone || !cat.isAddOn)
                .map((category) => {
                  const categoryProducts = getProductsByCategory(category.id);
                  if (categoryProducts.length === 0) return null;
                  
                  return (
                    <Accordion
                      key={category.id}
                      expanded={expandedPanel === category.id}
                      onChange={handleAccordionChange(category.id)}
                      style={{
                        backgroundColor: userData.themeTxtColor || '#fff',
                        marginBottom: '10px',
                        borderRadius: '10px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: `1px solid ${userData.themeColor}20`
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: userData.themeColor }} />}
                        style={{
                          backgroundColor: userData.themeColor + '10',
                          borderRadius: '10px',
                          minHeight: '60px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Avatar
                            src={getImageUrl(category.image)}
                            alt={category.name}
                            variant="rounded"
                            style={{ 
                              width: 40, 
                              height: 40, 
                              marginRight: '12px',
                              border: `2px solid ${userData.themeColor}`
                            }}
                          />
                          <Typography 
                            variant="h6" 
                            style={{ 
                              color: userData.themeColor,
                              fontWeight: 700,
                              flex: 1
                            }}
                          >
                            {category.name}
                          </Typography>
                          <Typography 
                            variant="body2" 
                            style={{ 
                              color: userData.themeColor + '80',
                              fontSize: '0.9rem'
                            }}
                          >
                            {categoryProducts.length} items
                          </Typography>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: '10px' }}>
                        <ProductList
                          items={categoryProducts}
                          baseURL={baseURL}
                          pgSets={pgSets}
                          userData={userData}
                          imageOnErrorHandler={imageOnErrorHandler}
                          productClickHandler={productClickHandler}
                          categories={categories ? categories : []}
                          selectedCat={{ id: category.id }}
                          style={{ backgroundColor: themeColor }}
                          t={t}
                          isLandscape={isLandscape}
                        />
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </Box>
          ) : userData?.OO_default_categoryView === 'chips_scroll' ? (
            // Chips scroll view for categories
            <Box>
              {/* Horizontal scrollable category chips - Rendered FIRST */}
              <Box style={{
                padding: '5px',
                backgroundColor: '#ffffff',
                borderBottom: 'none',
                position: 'sticky',
                top: 0,
                zIndex: 10
              }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    overflowX: 'scroll',
                    overflowY: 'hidden',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    padding: '5px 0px',
                    width: '100%',
                    WebkitOverflowScrolling: 'touch'
                  }}
                >
                  <style jsx>{`
                    div::-webkit-scrollbar {
                      display: none;
                    }
                    div {
                      -ms-overflow-style: none;
                      scrollbar-width: none;
                    }
                  `}</style>
                  {categories && categories
                    .filter(cat => cat.isOrderableAlone || !cat.isAddOn)
                    .map((category) => {
                      const categoryProducts = getProductsByCategory(category.id);
                      if (categoryProducts.length === 0) return null;
                      
                      return (
                        <Chip
                          key={category.id}
                          label={
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                              <Avatar
                                src={getImageUrl(category.image)}
                                alt={category.name}
                                style={{ 
                                  width: 24, 
                                  height: 24, 
                                 
                                }}
                              />
                              <span style={{ 
                                fontWeight: selectedCat?.id === category.id ? 700 : 500,
                                color: selectedCat?.id === category.id ? userData.themeTxtColor : 'inherit'
                              }}>
                                {category.name}
                              </span>
                              <span style={{ 
                                fontSize: '0.75rem',
                                opacity: 0.8,
                                color: selectedCat?.id === category.id ? userData.themeTxtColor : 'inherit'
                              }}>
                                ({categoryProducts.length})
                              </span>
                            </Box>
                          }
                          onClick={() => {
                            setSelectedCat(category);
                            setExpandedPanel(false);
                          }}
                          style={{
                            backgroundColor: selectedCat?.id === category.id ? userData.themeColor : 'transparent',
                            color: selectedCat?.id === category.id ? userData.themeTxtColor : userData.themeTxtColor,
                            border: `1px solid ${userData.themeTxtColor}`,
                            borderRadius: '25px',
                            fontWeight: '600',
                            fontSize: '0.9rem',
                            padding: '8px 4px',
                            height: 'auto',
                            minWidth: 'fit-content',
                            flexShrink: 0,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            whiteSpace: 'nowrap'
                          }}
                        />
                      );
                    })}
                </div>
              </Box>

              {/* Category Label and Products - Rendered AFTER chips */}
              <Box style={{ padding: '10px' }}>
                <Typography
                  variant="h6"
                  style={{
                    color: userData.themeTxtColor,
                    marginBottom: '15px',
                    fontWeight: 700,
                    textAlign: 'center'
                  }}
                >
                  {selectedCat ? selectedCat.name : 'All Items'}
                </Typography>
                <ProductList
                  items={selectedCat ? getProductsByCategory(selectedCat.id) : filteredProducts}
                  baseURL={baseURL}
                  pgSets={pgSets}
                  userData={userData}
                  imageOnErrorHandler={imageOnErrorHandler}
                  productClickHandler={productClickHandler}
                  categories={categories ? categories : []}
                  selectedCat={selectedCat}
                  style={{ backgroundColor: themeColor }}
                  t={t}
                  isLandscape={isLandscape}
                />
              </Box>
            </Box>
          ) : (
            // Default float button view - existing ProductList
            <ProductList
              items={filteredProducts}
              baseURL={baseURL}
              pgSets={pgSets}
              userData={userData}
              imageOnErrorHandler={imageOnErrorHandler}
              productClickHandler={productClickHandler}
              categories={categories ? categories : []}
              selectedCat={selectedCat}
              style={{ backgroundColor: themeColor }}
              t={t}
              isLandscape={isLandscape}
            />
          )}
        </Box>
      )}

      <Dialog
        onClose={closeHandler}
        aria-labelledby="max-width-dialog-title"
        open={ (!isLandscape && isCartOpen) || isCustomizeOpen}
        fullWidth={isLandscape ? false : true}
        maxWidth={isLandscape ? 'md' : 'xl'}
      >
        {isCustomizeOpen && <OrderCustomize
          orderItem={orderItem}
          setOrderItem={setOrderItem}
          baseURL={baseURL}
          imageOnErrorHandler={imageOnErrorHandler}
          quantity={quantity}
          categories={categories}
          setQuantity={setQuantity}
          orderItems={orderItems}
          items={products ? products : []}
          setIsCustomizeOpen={setIsCustomizeOpen}
          addToOrderHandler={addToOrderHandler}
          removeOrderItm={removeOrderItm}
          procedToCheckoutHandler={() => {
            setIsCustomizeOpen(false);
            setIsCartOpen(true);
          }}
          t={t}
          userData={userData}
          style={{ backgroundColor: userData.themeTxtColor }}
        />}

        {!isLandscape && isCartOpen && <CartReview
          t={t}
          orderItems={orderItems}
          setIsCartOpen={setIsCartOpen}
          productClickHandler={productClickHandler}
          categories={categories ? categories : []}
          procedToCheckoutHandler={procedToCheckoutHandler}
          style={{ backgroundColor: themeColor }}
          isLandscape={isLandscape}
        />}


      </Dialog>
      <Dialog
        onClose={() => setOpenSign(false)}
        aria-labelledby="max-width-dialog-title"
        open={openSign}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <SignUp setOpenSign={setOpenSign} procedToCheckoutHandler={procedToCheckoutHandler} />
      </Dialog>

      {/* Floating Category Button - Enhanced */}
      {!isLandscape && userData?.OO_default_categoryView !== 'collapsable' && userData?.OO_default_categoryView !== 'chips_scroll' && (
        <Zoom in={true}>
          <Fab
            aria-label="categories"
            style={{
              position: 'fixed',
              bottom: isMobile ? '80px' : '30px',
              right: isMobile ? '20px' : '30px',
              backgroundColor: themeColor,
              color: themeTxtColor,
              zIndex: 1000,
              boxShadow: '0 4px 14px rgba(0,0,0,0.25)'
            }}
            onClick={handleToggle}
            ref={anchorRef}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <RestaurantMenuIcon />
              <div>MENU</div>
            </div>
          </Fab>
        </Zoom>
      )}

      <Popper open={isCategoryMenuOpen} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ overflow: 'auto', maxHeight: "400px" }}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={isCategoryMenuOpen} id="menu-list-grow">
                  {categories && categories.map((category) => (
                    <MenuItem
                      key={category.id}
                      onClick={() => categoryClickHandler(category)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        borderBottom: '1px solid rgba(0,0,0,0.1)',
                        padding: '12px 16px'
                      }}
                    >
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        marginRight: '10px'
                      }}>
                        <img
                          src={getImageUrl(category.image)}
                          alt={category.name}
                          onError={imageOnErrorHandler}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                      <Typography variant="body1" style={{ fontWeight: 600 }}>{category.name}</Typography>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <Popper
        open={showSearchInput || showPickupAddress}
        anchorEl={searchAnchorEl}
        placement="bottom-end"
        transition
        style={{ zIndex: 99999 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'center top', transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
            <div style={{ position: 'relative', width: '100%', maxWidth: '98vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Paper style={{
                padding: '10px',
                background: setting.themeColor,
                border: `2px solid ${setting.themeTxtColor}`,
                borderRadius: '10px',
                margin: '8px 0 8px 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
                minWidth: 0,
                height: '48px',
                width: '100%',
                maxWidth: 320,
                color: setting.themeTxtColor,
                fontFamily: setting.themeSecondaryFontFam
              }}>
                <ClickAwayListener onClickAway={() => {
                  setShowSearchInput(false);
                  setShowPickupAddress(false);
                  setSearchAnchorEl(null);
                }}>
                  {showPickupAddress ? <div>
                    <span style={{ color: "#fff" }}>Your address: </span>
                    {customersInfo?.customer?.address || 'Not available'}</div> :


                    <form style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 0, padding: 0 }} onSubmit={e => { e.preventDefault(); }}>
                      <input
                        autoFocus
                        type="text"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        placeholder="Search menu items..."
                        style={{
                          width: '100%',
                          maxWidth: 250,

                          fontFamily: setting.themeSecondaryFontFam,
                          outline: 'none',
                          fontSize: '0.9em',
                          color: '#fff',
                          border: 'none',
                          height: '35px',
                          fontWeight: 400,
                          letterSpacing: '0.01em',
                          fontFamily: 'inherit',
                          margin: "10px",
                          backgroundColor: 'transparent',
                          transition: 'border 0.18s',
                          '::placeholder': {
                            color: '#fff',
                            opacity: 1,
                          },
                        }}
                      />
                    </form>}
                </ClickAwayListener>
              </Paper>
            </div>
          </Grow>
        )}
      </Popper>
      {!isLandscape && !isCustomizeOpen && !isCartOpen && (
        <MainFooter tabSel={0} />
      )}
    </Box>
  );
}
